import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/providers/shared/shared.service';

@Component({
  selector: 'app-loged',
  templateUrl: './loged.component.html',
  styleUrls: ['./loged.component.css']
})
export class LogedComponent implements OnInit {

  constructor(private shared:SharedService) { }

  ngOnInit(): void {
  }

}
